
  import { Component, Vue } from "vue-property-decorator";

  @Component({})
  export default class Tip6 extends Vue {}
